<script setup lang="ts">
  import { computed, watch } from "vue";
  import { useAppStore } from '@/stores/app';
  import { useSubscriptionFlowStore } from "@/stores/subscriptionFlow";
  import Reminder from "@/components/Reminder.vue";
  import * as amplitude from "@amplitude/analytics-browser";

  const appStore = useAppStore();
  const subscriptionFlowStore = useSubscriptionFlowStore();

  const show = computed(() => appStore.showSweepStakesReminder && !subscriptionFlowStore.showModal && !appStore.showReferralRockModal);

  watch(show, (value) => {
    if (value) {
      amplitude.track('In-app Reminder Displayed', {
        'Reminder Type': 'Sweepstakes',
      });
    }
  });

  function handleClick() {
    appStore.showSweepStakesReminder = false;
    appStore.showSweepStakesModal = true;

    amplitude.track('In-app Reminder Clicked', {
      'Reminder Type': 'Sweepstakes',
    });
  }

  function handleClose() {
    appStore.showSweepStakesReminder = false;

    amplitude.track('In-app Reminder Closed', {
      'Reminder Type': 'Sweepstakes',
    });
  }

</script>

<template>
  <Reminder
    :model-value="show"
    :title="$t('reminders.sweepstakes.title')"
    :subTitle="$t('reminders.sweepstakes.subtitle')"
    icon="confirmation_number"
    :cta="handleClick"
    @close="handleClose"
  ></Reminder>
</template>

<style scoped lang="scss">
</style>
